import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PaperPanelContainer } from './styled';

const PanelHeaderContainer = styled.div`
margin-bottom: 36px;
`;

const PaperPanel = ({ header, children, style }) => (
  <PaperPanelContainer style={style}>
    <PanelHeaderContainer>{header}</PanelHeaderContainer>
    {children}
  </PaperPanelContainer>
);

PaperPanel.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node,
  style: PropTypes.object
};

PaperPanel.defaultProps = {
  header: null,
  children: null,
  style: undefined
};

export default PaperPanel;
